import { render, staticRenderFns } from "./InterventionDataForm.vue?vue&type=template&id=89034634&scoped=true&"
import script from "./InterventionDataForm.vue?vue&type=script&lang=js&"
export * from "./InterventionDataForm.vue?vue&type=script&lang=js&"
import style0 from "./InterventionDataForm.vue?vue&type=style&index=0&id=89034634&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89034634",
  null
  
)

export default component.exports